<script setup lang="ts">
import { useAttrs, type PropType } from 'vue'
import type { UnionFromTuple } from '@oen.web.vue/utils'
import OenUiButtonShared from '../OenUiButtonShared/OenUiButtonShared.vue'
import { sharedButtonProps } from '../OenUiButtonShared/props'
import { types } from '../OenUiButtonShared/variants'

type Type = UnionFromTuple<typeof types>

defineProps({
  ...sharedButtonProps,
  type: {
    type: String as PropType<Type>,
    default: 'button',
    validator(type: (typeof types)[number]) {
      return types.includes(type)
    },
  },
})

const attrs = useAttrs()
</script>

<template>
  <OenUiButtonShared
    button-type="button"
    :theme="theme"
    :type="type"
    v-bind="attrs"
    :loading="loading"
    :analytics-name="analyticsName"
  >
    <template v-for="(_, slot) in $slots" #[slot]>
      <slot :name="slot" />
    </template>
  </OenUiButtonShared>
</template>
